export default __webpack_public_path__ + "img/font.17c8de79.svg";